module.exports = __webpack_public_path__ + "static/media/GiveMeaSign.cdd58f5a.jpg";